import { IGLCodeRepositoryResponse } from "@/core/repositories/lookup";
import { LookupRepository } from "@/infrastructure/repositories/lookup";

export class GetGLCodeUseCase {
  constructor(private readonly lookupRepository: LookupRepository) {}

  async execute(): Promise<IGLCodeRepositoryResponse> {
    return this.lookupRepository.getGLCodes();
  }
}
